import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import UtilisateursVue from "../../../components/Admin/Utilisateurs/UtilisateursVue";
import Routing from "../../../services/routing";

function AdminSalariesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId, contratId, activiteId, seanceId} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [entreprise, setEntreprise] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const navigate = useNavigate();

    useEffect(() => {
        if (mode === 'creation') {
            navigate(Routing.generate({ route: Routing.routes.adminUtilisateurs, queryParams: {mode: "creation", entreprise: entrepriseId}}));
            // navigate(`/admin/utilisateurs?mode=creation&entreprise=${entrepriseId}`);
        }
    }, [mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise: { id: entrepriseId } })); // Todo faire une req pour recup le nom de l'entreprise
    }, [ entreprise ]);

    return (
        <div className="content_tab">
            <TitleMain text="Salariés"/>

            <UtilisateursVue idEnt={entrepriseId} />

        </div>
    )
}

export default AdminSalariesPage;
